import Alpine from "alpinejs";
import type TreeRoot from "../components/TreeRoot";
import { getCurrentSelectionRange } from "../handlers/selection";
import { pipeline } from "../handlers/updates";

(window as any)["qs"] = function () {
  const qs = new URLSearchParams(window.location.search);
  const values = Array.from(qs.entries());
  const obj: any = {};
  for (let kv of values) {
    obj[kv[0]] = kv[1];
  }
  return obj;
};

/**
 * Expose the getCurrentSelectionRange function to the global scope for debugging purposes.
 */
(window as any).getEditorSelection = async () => {
  const selection = await getCurrentSelectionRange();
  console.time("Document Selection");
  console.log("Document Selection:", selection);
  console.timeEnd("Document Selection");
  return selection;
};

(window as any)["reupload"] = function () {
  return pipeline.update();
};

(window as any)["refresh"] = function () {
  document.dispatchEvent(new CustomEvent("refresh"));
};

(window as any)["testSentry"] = function () {
  throw new Error("Sentry source map test");
};

(window as any)["updateSticky"] = function () {
  const target = document.querySelector(".tree-root") as HTMLElement | null;
  if (target == null) {
    console.error("could not find root");
    return;
  }

  const root = Alpine.$data(target) as TreeRoot;
  console.time("compute");
  root.applyStickyAndLast();
  console.timeEnd("compute");
};